
<div class="m-dropdown m-dropdown--inline m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push">
    <a href="#" class="m-portlet__nav-link btn btn-secondary  m-btn m-btn--air m-btn--pill" (click)="openRightMenu()">
        Filters&nbsp;(&nbsp;<span class="actfltrs">0</span>&nbsp;)&nbsp;<i class="fa fa-sliders" aria-hidden="true"></i>
    </a>
</div>
<div class="w3-sidebar w3-bar-block w3-card w3-animate-right" style="display:none;right:0;top: 0px; overflow-y: auto;" id="rightMenu">
        <div class="col-sm-12">
            <div class="row"><div class="col-sm-12 m--align-right">
                <button (click)="closeRightMenu()" class="btn btn-secondary">Close&nbsp;<i class="la la-times"></i></button>
            </div></div>
            <div class="row"><div class="col-sm-12">
                <h5>Select time range</h5>    
                <div class="form-group">
                    <div id="reportrange" class="form-control pull-left" style="background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%; height: auto; min-height: 34px;">
                        <i class="icon icon-calendar"></i>&nbsp;
                        <span></span> <b class="caret"></b>
                    </div>
                </div>
            </div></div>
            <div class="row"><div class="col-sm-12">&nbsp;</div></div>
            <div class="row"><div class="col-sm-12">
                <h5>Select time zone</h5>
                <div class="form-group">
                    <select id="selecttimezone" class="form-control m-select2 m-select2-hidden-accessible col-sm-12" tabindex="-1" aria-hidden="true" data-placeholder="Please select a time zone" style="width: 364px;" >
                        <option value="LOCAL">Local time zone</option>
                    </select>
                </div>
            </div></div>
            <div class="row"><div class="col-sm-12">&nbsp;</div></div>
            <div class="row"><div class="col-sm-12">
                <h5>Select a location group</h5>
                <div class="form-group">
                    <select id="selectlocgroup" class="form-control m-select2 m-select2-hidden-accessible col-sm-12" tabindex="-1" aria-hidden="true" data-placeholder="Please select a location" style="width: 364px;" >
                        <option value="NONE">No location group</option>
                    </select>
                </div>
            </div></div>
            <div class="row"><div class="col-sm-12">
                <h5>Select a location</h5>
                <div class="form-group">
                    <select id="selectloc" class="form-control m-select2 m-select2-hidden-accessible col-sm-12" tabindex="-1" aria-hidden="true" data-placeholder="Please select a location" style="width: 364px;" >
                    </select>
                </div>
            </div></div>
            <div class="row"><div class="col-sm-12">
                <div class="form-body">
                    <div class="form-group pull-left">
                        <button id="filter-search" type="button" class="btn btn-brand" (click)="searching()">UPDATE</button>
                    </div>
                </div>
            </div></div>
        </div>
</div>
<style type="text/css">.daterangepicker.dropdown-menu,.select2-dropdown{z-index: 10001;}.daterangepicker.dropdown-menu.show-calendar{width: 830px !important;}</style>